import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const BusinessPremiumFinanceListWarpper = Loadable(
  lazy(() =>
    import(
      "./BusinessPremiumFinanceListWrapper"
    ).then(({ BusinessPremiumFinanceListWarpper }) => ({
      default: BusinessPremiumFinanceListWarpper,
    }))
  )
);
const Premium = Loadable(
  lazy(() =>
    import("./BusinessPremiumFinance").then(
      ({ BusinessPremiumFinance }) => ({
        default: BusinessPremiumFinance,
      })
    )
  )
);

export const BusinessPremiumFinanceRoutes = [
  {
    path: `/business-policy/:customerId/premium-finance/:customerPolicyId/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessPremiumFinanceListWarpper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/premium-finance/:customerPolicyId/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Premium />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/premium-finance/:customerPolicyId/manage/:premiumNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Premium />
      </AuthorizedRoute>
    ),
  },
];
